var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.000000pt",
    height: "12.000000pt",
    viewBox: "0 0 240.000000 240.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,240.000000) scale(0.100000,-0.100000)",
    fill: "grey",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1692 2257 l-142 -142 283 -283 282 -282 143 143 142 142 -283 283 -282 282 -143 -143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845 1410 l-560 -560 283 -282 282 -283 562 562 563 563 -280 280 c-154 154 -282 280 -285 280 -3 0 -257 -252 -565 -560z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 358 c-39 -194 -70 -354 -70 -355 2 -1 685 135 700 140 4 1 -120 130 -276 285 l-284 284 -70 -354z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.87db91677577d7b875de84e9780700e6.svg";
export { ForwardRef as ReactComponent };